(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flow-social-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flow-social-gallery')) {
  customElements.define('flow-social-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const track = this.querySelector('.ff-social__track');
      const previous = this.querySelector('.swiper-prev');
      const next = this.querySelector('.swiper-next');
      if (!track || !previous || !next) return;
      const update = () => {
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const advance = direction => {
        const card = track.querySelector('.ff-social__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).gap) || 16;
        const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: reduceMotion ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => advance(-1), {signal:this.controller.signal});
      next.addEventListener('click', () => advance(1), {signal:this.controller.signal});
      track.addEventListener('scroll', update, {passive:true,signal:this.controller.signal});
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flowdays-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flowdays-popup')) {
    customElements.define('flowdays-popup', class extends HTMLElement {
      connectedCallback() {
        const dialog = this.querySelector('dialog');
        if (!dialog) return;

        // Phase: 'sale' until data-ends (FlowDays), then 'welcome' (newsletter offer with data-welcome-code).
        const ends = Date.parse(this.dataset.ends || '');
        const welcomeCode = String(this.dataset.welcomeCode || '').toUpperCase();
        const saleOver = Boolean(ends && Date.now() > ends);
        if (saleOver && !welcomeCode) {
          document.documentElement.dataset.flowPhase = 'none';
          document.querySelectorAll('flow-newsletter-offer').forEach((el) => { el.style.display = 'none'; });
          return;
        }
        const phase = saleOver ? 'welcome' : 'sale';
        const code = saleOver ? welcomeCode : String(this.dataset.code || '').toUpperCase();
        this.dataset.activeCode = code;
        // Exposed on <html> so the cart drawer offer (snippets/flow-cart-newsletter-cta.liquid) shows the right text, or hides once subscribed.
        document.documentElement.dataset.flowPhase = phase;
        if (saleOver) {
          dialog.setAttribute('aria-labelledby', 'FlowDaysPopupTitleWelcome');
          const tags = this.querySelector('input[name="contact[tags]"]');
          if (tags) tags.value = 'newsletter, welcome';
        }
        this.querySelectorAll('[data-flowdays-phase]').forEach((el) => { el.hidden = el.dataset.flowdaysPhase !== phase; });
        document.querySelectorAll('flow-newsletter-offer [data-offer-phase]').forEach((el) => { el.hidden = el.dataset.offerPhase !== phase; });

        const store = (s, k, v) => { try { v === undefined ? s.removeItem(k) : s.setItem(k, v); } catch (e) {} };
        const read = (s, k) => { try { return s.getItem(k); } catch (e) { return null; } };
        const remember = () => store(localStorage, 'flowdays-popup-dismissed', String(Date.now()));
        const markSubscribed = () => {
          store(localStorage, 'flowdays-subscribed', '1');
          store(localStorage, 'flow-newsletter-code', code);
          document.documentElement.setAttribute('data-flow-subscribed', '');
        };
        if (read(localStorage, 'flowdays-subscribed') === '1') document.documentElement.setAttribute('data-flow-subscribed', '');
        const cookieHasCode = () => document.cookie.split('; ').some((c) => c.indexOf('discount_code=') === 0 && decodeURIComponent(c.slice(14)).toUpperCase().indexOf(code) !== -1);
        // Source of truth: the cart itself, whatever way the code was applied (pop-up, email link, flowdays page, typed in).
        const cartHasCode = () => fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const codes = (cart.discount_codes || []).map((d) => String(d.code || '').toUpperCase());
            const apps = (cart.cart_level_discount_applications || []).map((d) => String(d.title || '').toUpperCase());
            return codes.includes(code) || apps.includes(code);
          })
          .catch(() => false);
        const hasCode = () => (cookieHasCode() ? Promise.resolve(true) : cartHasCode());
        const show = (step) => {
          this.querySelectorAll('[data-flowdays-step]').forEach((el) => { el.hidden = el.dataset.flowdaysStep !== step; });
          if (!dialog.open) dialog.showModal();
        };
        this.querySelectorAll('[data-flowdays-close]').forEach((b) => b.addEventListener('click', () => {
          remember();
          dialog.close();
          // Signed up from the cart drawer offer: bring the customer back to their (now discounted) cart.
          const success = !this.querySelector('[data-flowdays-step="success"]').hidden;
          if (read(sessionStorage, 'flowdays-from-cart') === '1') {
            store(sessionStorage, 'flowdays-from-cart');
            if (success && typeof window.updateMiniCart === 'function') window.updateMiniCart(true);
          }
        }));
        dialog.addEventListener('cancel', remember);

        // Product-page offer line (and any [data-flowdays-open] link) opens the pop-up instead of leaving the page.
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest && event.target.closest('[data-flowdays-open]');
          if (!trigger) return;
          event.preventDefault();
          if (trigger.closest('.flow-cart-cta')) store(sessionStorage, 'flowdays-from-cart', '1');
          hasCode().then((applied) => {
            if (applied) { markSubscribed(); show('success'); return; }
            if (read(localStorage, 'flowdays-subscribed') === '1') {
              // Already subscribed but the code is no longer in the cart (e.g. emptied cart): re-apply the code they signed up with.
              const own = String(read(localStorage, 'flow-newsletter-code') || (saleOver ? '' : code)).toUpperCase();
              if (own === code) fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(() => {});
              show('success');
              return;
            }
            show('form');
          });
        });

        const form = this.querySelector('form');
        form?.addEventListener('submit', (event) => {
          const input = form.querySelector('input[type="email"]');
          if (input && !input.checkValidity()) { event.preventDefault(); input.reportValidity(); return; }
          store(sessionStorage, 'flowdays-submitted', '1');
        });

        const mine = read(sessionStorage, 'flowdays-submitted') === '1';
        const params = new URLSearchParams(location.search);

        // After the /discount redirect below: show the success step (code is now attached to the cart server-side).
        if (read(sessionStorage, 'flowdays-show-success') === '1') {
          store(sessionStorage, 'flowdays-show-success');
          remember();
          show('success');
          return;
        }

        // Any newsletter sign-up on the site (pop-up or footer) applies the current code right away.
        // We navigate through /discount/CODE so Shopify attaches the code to the cart before the page is rendered:
        // the cart drawer then shows the discounted price immediately, even if items were added before signing up
        // and in the Instagram in-app browser.
        if (params.get('customer_posted') === 'true') {
          store(sessionStorage, 'flowdays-submitted');
          markSubscribed();
          if (mine) store(sessionStorage, 'flowdays-show-success', '1');
          params.delete('customer_posted');
          const qs = params.toString();
          const back = location.pathname + (qs ? '?' + qs : '');
          location.replace('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back));
          return;
        }

        if (mine && this.querySelector('[data-flowdays-error]')) {
          store(sessionStorage, 'flowdays-submitted');
          show('form');
          return;
        }

        // Visitors coming from our emails, or who already have the code applied, never see the automatic pop-up.
        if (/(^|&)(utm_source=shopify_email|utm_medium=email)(&|$)/i.test(location.search.slice(1))) {
          store(sessionStorage, 'flowdays-no-popup', '1');
        }
        if (read(sessionStorage, 'flowdays-no-popup') === '1') return;
        if (read(localStorage, 'flowdays-subscribed') === '1') return;
        const dismissed = Number(read(localStorage, 'flowdays-popup-dismissed') || 0);
        if (location.pathname.endsWith('/pages/flowdays') || Date.now() - dismissed <= 7 * 24 * 60 * 60 * 1000) return;
        hasCode().then((applied) => {
          if (applied) { markSubscribed(); return; }
          setTimeout(() => { if (!dialog.open) show('form'); }, 2000);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-image-hotspots"] && !Shopify.designMode) return;
  try {
    const fitProductHotspot = (hotspot) => {
    const container = hotspot.closest('[data-product-hotspots]');
    const label = hotspot.querySelector('.ff-product-hotspot__label');
    const summary = hotspot.querySelector('summary');
    if (!container || !label || !summary || !hotspot.open) return;
    const mobile = window.matchMedia('(max-width: 63.99em)').matches;
    hotspot.removeAttribute('data-label-fitted');
    const bounds = container.getBoundingClientRect();
    const button = summary.getBoundingClientRect();
    const margin = mobile ? 8 : 12;
    const gap = mobile ? 8 : 10;
    const radius = mobile ? 12 : 14;
    label.style.maxWidth = `${Math.max(0, Math.min(mobile ? 150 : 240, bounds.width - margin * 2))}px`;
    hotspot.setAttribute('data-label-fitted', '');
    const { width, height } = label.getBoundingClientRect();
    const centerX = button.left + button.width / 2;
    const centerY = button.top + button.height / 2;
    const buttons = [...container.querySelectorAll('summary')].map((item) => {
      const rect = item.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;
      return { left: x - radius, right: x + radius, top: y - radius, bottom: y + radius };
    });
    const productAreas = container.dataset.productBounds.split(';').map((area) => {
      const [left, top, right, bottom] = area.split(',').map(Number);
      return { left: bounds.left + bounds.width * left / 100, top: bounds.top + bounds.height * top / 100, right: bounds.left + bounds.width * right / 100, bottom: bounds.top + bounds.height * bottom / 100 };
    });
    const candidates = {
      up: [centerX - width / 2, centerY - radius - height - gap],
      down: [centerX - width / 2, centerY + radius + gap],
      left: [centerX - radius - width - gap, centerY - height / 2],
      right: [centerX + radius + gap, centerY - height / 2]
    };
    const preferred = ['up', 'down', 'left', 'right'].find((direction) => hotspot.classList.contains(`ff-product-hotspot--${direction}`)) || 'up';
    const ranked = [preferred, ...Object.keys(candidates).filter((direction) => direction !== preferred)].map((direction, index) => {
      const [rawX, rawY] = candidates[direction];
      const x = Math.max(bounds.left + margin, Math.min(rawX, bounds.right - width - margin));
      const y = Math.max(bounds.top + margin, Math.min(rawY, bounds.bottom - height - margin));
      const overlap = buttons.reduce((total, rect) => total + Math.max(0, Math.min(x + width, rect.right + 6) - Math.max(x, rect.left - 6)) * Math.max(0, Math.min(y + height, rect.bottom + 6) - Math.max(y, rect.top - 6)), 0);
      const productOverlap = productAreas.reduce((total, area) => total + Math.max(0, Math.min(x + width, area.right) - Math.max(x, area.left)) * Math.max(0, Math.min(y + height, area.bottom) - Math.max(y, area.top)), 0);
      const displaced = Math.abs(x - rawX) + Math.abs(y - rawY);
      return { x, y, score: overlap * 1000 + displaced * 20 + productOverlap * 0.02 + index * 2 };
    }).sort((a, b) => a.score - b.score);
    const best = ranked[0];
    const origin = hotspot.getBoundingClientRect();
    hotspot.style.setProperty('--ff-label-left', `${best.x - origin.left}px`);
    hotspot.style.setProperty('--ff-label-top', `${best.y - origin.top}px`);
  };

  document.addEventListener('toggle', (event) => {
    const hotspot = event.target;
    if (!(hotspot instanceof HTMLDetailsElement) || !hotspot.matches('.ff-product-hotspot')) return;

    const container = hotspot.closest('[data-product-hotspots]');
    if (hotspot.open) {
      container.querySelectorAll('.ff-product-hotspot[open]').forEach((item) => {
        if (item !== hotspot) item.removeAttribute('open');
      });
      fitProductHotspot(hotspot);
      requestAnimationFrame(() => fitProductHotspot(hotspot));
    }
  }, true);

  window.addEventListener('resize', () => {
    document.querySelectorAll('.ff-product-hotspot[open]').forEach(fitProductHotspot);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ff-product-hotspot[open]').forEach((hotspot) => {
      hotspot.removeAttribute('open');
      hotspot.querySelector('summary')?.focus();
    });
  });

  const bindProductHotspots = (scope = document) => {
    scope.querySelectorAll('[data-product-hotspots]').forEach((container) => {
      if (container.dataset.hotspotsBound) return;
      container.dataset.hotspotsBound = 'true';
      container.querySelectorAll('summary').forEach((summary) => {
        summary.addEventListener('click', (event) => event.stopPropagation());
        summary.addEventListener('pointerdown', (event) => event.stopPropagation());
      });
      const gallery = container.closest('swiper-container');
      gallery?.addEventListener('swiperslidechange', () => {
        const active = gallery.swiper?.realIndex === 0;
        if (!active) container.querySelectorAll('details[open]').forEach((item) => item.removeAttribute('open'));
      });
      new ResizeObserver(() => container.querySelectorAll('details[open]').forEach(fitProductHotspot)).observe(container);
      const labelObserver = new ResizeObserver((entries) => {
        entries.forEach(({ target }) => fitProductHotspot(target.closest('details')));
      });
      container.querySelectorAll('.ff-product-hotspot__label').forEach((label) => labelObserver.observe(label));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindProductHotspots());
  } else {
    bindProductHotspots();
  }
  document.addEventListener('shopify:section:load', (event) => bindProductHotspots(event.target));
  } catch(e) { console.error(e); }
})();

})();
